import Swal from "sweetalert2";

export const handleMessage = (message?: string, html?: string) => {
  message &&
    Swal.fire({
      text: message,
      background: "transparent",
      backdrop:
        "radial-gradient(50% 50% at 50% 50%, #000000 0%, rgba(0, 0, 0, 0.6) 100%)",
      customClass: {
        popup: "no-border",
      },
      color: "#ffffff",
      timer: 2000,
      showConfirmButton: false,
      timerProgressBar: false,
    });

  html &&
    Swal.fire({
      background: "transparent",
      backdrop:
        "radial-gradient(50% 50% at 50% 50%, #000000 0%, rgba(0, 0, 0, 0.6) 100%)",
      html: html,
      customClass: {
        popup: "no-border",
      },
      color: "#ffffff",
      timer: 2000,
      showConfirmButton: false,
      timerProgressBar: false,
    });
};
